module.exports = "<a  target=\"_blank\" href=\"https://www.i-real.nl\">\n  <img src=\"assets/ireal-logo.png\" />\n</a>"